import { render, staticRenderFns } from "./Syndic.vue?vue&type=template&id=7e3f7d2a&"
import script from "./Syndic.vue?vue&type=script&lang=js&"
export * from "./Syndic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports